import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ICompanyDetails, CompanyDetails } from '@core/entities/company'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

const dataTransformer = (response: ICompanyDetails) => {
  return CompanyDetails.new(response)
}

export const useGetCompanyDetails = (
  payload: RequestTypes['getCompanyDetails'],
  options?: UseQueryOptions<ICompanyDetails, RequestErrorType, CompanyDetails>,
) => {
  return useQuery({
    select: dataTransformer,
    ...companyKeys.getCompanyDetails(payload),
    ...options,
  })
}
